import {
  FETCH_CAR_TYPES,
  FETCH_CAR_TYPES_SUCCESS,
  FETCH_CAR_TYPES_FAILED,
  EDIT_CAR_TYPE
} from "../store/types";
import store from '../store/store';
import { getSupabase } from '../config/configureSupabase';

export const DEFAULT_CAR_TYPES = [
  {
    id: '00000000-0000-0000-0000-000000000001',
    name: 'Carro',
    description: 'Carro de passeio padrão (Hatch/Sedan)',
    pos: 1,
    image: '/images/cartypes/carro.png',
    is_default: true,
    base_fare: 0,
    rate_per_unit_distance: 0
  },
  {
    id: '00000000-0000-0000-0000-000000000002',
    name: 'Moto',
    description: 'Motocicleta / Veículo de 2 rodas',
    pos: 2,
    image: '/images/cartypes/moto.png',
    is_default: true,
    base_fare: 0,
    rate_per_unit_distance: 0
  },
  {
    id: '00000000-0000-0000-0000-000000000003',
    name: 'Van/Onibus',
    description: 'Van, micro-ônibus ou transporte coletivo',
    pos: 3,
    image: '/images/cartypes/van_onibus.png',
    is_default: true,
    base_fare: 0,
    rate_per_unit_distance: 0
  }
];

export const fetchCarTypes = () => async (dispatch) => {
  const supabase = getSupabase();
  if (supabase) {
    dispatch({
      type: FETCH_CAR_TYPES,
      payload: null
    });
    try {
      const userInfo = store.getState().auth?.profile;
      let query = supabase.from('cartypes').select('*').order('pos', { ascending: true });
      if (userInfo?.tenant_id) {
        query = query.or(`tenant_id.is.null,tenant_id.eq.${userInfo.tenant_id}`);
      }
      const { data, error } = await query;
      if (!error && data && data.length > 0) {
        dispatch({
          type: FETCH_CAR_TYPES_SUCCESS,
          payload: data
        });
        return;
      }
    } catch (e) {
      console.warn('fetchCarTypes error, fallback to defaults:', e);
    }
  }

  // Fallback garantido para os 3 tipos padrão do sistema
  dispatch({
    type: FETCH_CAR_TYPES_SUCCESS,
    payload: DEFAULT_CAR_TYPES
  });
};

export const editCarType = (cartype, method) => async (dispatch) => {
  // Proibir qualquer modificação ou exclusão dos tipos padrão
  if (cartype?.is_default || cartype?.id?.startsWith('00000000-0000-0000-0000-00000000000')) {
    console.warn('[editCarType] Tipos de veículos padrão do sistema são fixos e não podem ser alterados.');
    alert('Os tipos de veículo padrão do sistema (Carro, Moto e Van/Onibus) são fixos e não podem ser modificados.');
    return;
  }

  const profile = store.getState().auth?.profile;
  const isSuperAdmin = Boolean(
    profile?.is_superadmin || profile?.role === 'superadmin' || profile?.usertype === 'superadmin'
  );
  if (!isSuperAdmin) {
    console.warn('[editCarType] Usuários de tenant não possuem permissão para gerenciar tipos de veículo.');
    alert('Apenas o Super Admin tem permissão para gerenciar tipos de veículo.');
    return;
  }

  const supabase = getSupabase();
  if (supabase) {
    dispatch({
      type: EDIT_CAR_TYPE,
      payload: { method, cartype }
    });
    const record = {
      name: cartype.name,
      description: cartype.description || '',
      image: cartype.image || '',
      rate_per_unit_distance: cartype.rate_per_unit_distance || 0,
      base_fare: cartype.base_fare || 0,
      pos: cartype.pos || 1,
      tenant_id: cartype.tenant_id || profile?.tenant_id
    };

    if (method === 'Add') {
      await supabase.from('cartypes').insert([record]);
    } else if (method === 'Delete') {
      await supabase.from('cartypes').delete().eq('id', cartype.id);
    } else {
      await supabase.from('cartypes').update(record).eq('id', cartype.id);
    }
    dispatch(fetchCarTypes());
  }
};